import type { LiveCategory } from "@/types/live";

export const categories: LiveCategory[] = [
  {
    key: "entertainment",
    name: "娱乐表演",
    icon: "ri-emotion-happy-line",
    intro: "歌舞、脱口秀、综艺连麦等轻松欢乐的娱乐直播，随时开怀大笑。",
    color: "primary",
  },
  {
    key: "game",
    name: "网络游戏",
    icon: "ri-gamepad-line",
    intro: "热门手游、端游与电竞对局直播，和高玩一起排位开黑。",
    color: "accent",
  },
  {
    key: "talent",
    name: "才艺展示",
    icon: "ri-magic-line",
    intro: "舞蹈、绘画、手工、乐器等才艺主播在线秀场，才华与颜值齐飞。",
    color: "secondary",
  },
  {
    key: "chat",
    name: "聊天互动",
    icon: "ri-chat-smile-2-line",
    intro: "深夜电台、连麦闲聊与情感话题，找到最懂你的声音。",
    color: "primary",
  },
  {
    key: "music",
    name: "音乐现场",
    icon: "ri-music-2-line",
    intro: "现场弹唱、翻唱与原创音乐分享，让耳朵享受一场小型演唱会。",
    color: "accent",
  },
  {
    key: "outdoor",
    name: "户外生活",
    icon: "ri-roadster-line",
    intro: "城市漫游、露营旅行与美食探店，跟着主播看更广阔的世界。",
    color: "secondary",
  },
];